import React from "react";
import cx from "classnames";
import AppConstants from "../../constants/AppConstants";
import When from "../utils/When";
import UIActions from "../../actions/UIActions";
import ContextMenu from "../ContextMenu";

const { LAYOUT_DESKTOP, LAYOUT_MOBILE } = AppConstants;

const SyncToggle = ({ active = false, layout, clickAction, activeLayout = "" }) => {
  const [hovered, setHovered] = React.useState(false);
  const iconClassName = [LAYOUT_DESKTOP, LAYOUT_MOBILE].includes(layout)
    ? `icon icon-${layout}`
    : `glyphicon glyphicon-${layout === "unlock" && hovered ? "lock" : layout}`;

  return (
    <button
      type="button"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title={layout === LAYOUT_DESKTOP ? "Desktop" : "Mobile"}
      className={`toggle ${layout}${active ? " active" : ""}`}
      onClick={clickAction}
    >
      <span className={iconClassName} />
    </button>
  );
};

const SyncToggles = ({ layout }) => {
  const clickAction = (clickedLayout) => () =>
    UIActions.selectActiveLayout({ layout: clickedLayout, from: "panel" });

  return (
    <div className="toggles">
      <SyncToggle
        active={LAYOUT_MOBILE === layout}
        layout={LAYOUT_MOBILE}
        clickAction={clickAction(LAYOUT_MOBILE)}
      />
      <SyncToggle
        active={LAYOUT_DESKTOP === layout}
        layout={LAYOUT_DESKTOP}
        clickAction={clickAction(LAYOUT_DESKTOP)}
      />
    </div>
  );
};

const ControlGroup = (props) => {
  const {
    baseClassName = "si-c-control-group",
    className,
    split = false,
    label = "",
    toggleSync,
    children,
    layout,
    ...other
  } = props;

  return (
    <div className={cx(baseClassName, className)} {...other}>
      <When it={split}>
        <div className="si-c-controls">
          <SyncToggles layout={layout} />
        </div>
        {children}
      </When>
      <When it={!split}>{children}</When>
    </div>
  );
};

export default ControlGroup;
